import { render, staticRenderFns } from "./SendEmailItem.vue?vue&type=template&id=19d24efc&scoped=true&"
import script from "./SendEmailItem.vue?vue&type=script&lang=js&"
export * from "./SendEmailItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d24efc",
  null
  
)

export default component.exports